module.exports = require('./readable').Transform



// WEBPACK FOOTER //
// (webpack)/~/readable-stream/transform.js